import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledList,
  StyledElement,
  StyledIcon,
  StyledButtonLeft
} from './style';

import { ArrowLeft } from '../../../../assets/images/index';

const Breadcrumb = ({ className, dataList, onClick }) => {
  const totalTextChar = dataList.reduce(
    (acc, item) => acc + item.txt.length,
    0
  );
  const formatId = id => {
    if (totalTextChar >= 70 && id.length > 10) {
      return `${id.substring(0, 10)}...`;
    }
    return id;
  };
  return (
    <nav className={className}>
      {dataList.map(
        (item, index) =>
          index > 0 && (
            <StyledButtonLeft
              key={item.id}
              onClick={() => onClick(dataList[index - 1])}
              title={item.txt}
            >
              <StyledIcon svg={ArrowLeft} />
            </StyledButtonLeft>
          )
      )}
      <StyledList>
        {dataList.map((item, index) => (
          <React.Fragment key={item.id}>
            <StyledElement
              tabindex="0"
              onClick={() => onClick(item)}
              title={item.txt}
            >
              {index > 0 && <StyledIcon svg={ArrowLeft} />}
              {formatId(item.txt)}
            </StyledElement>
          </React.Fragment>
        ))}
      </StyledList>
    </nav>
  );
};

Breadcrumb.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  dataList: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      dataList: PropTypes.arrayOf(
        PropTypes.shape({
          txt: PropTypes.string,
          id: PropTypes.string
        })
      )
    })
  )
};

export default Breadcrumb;
